(function () {
    if (document.querySelectorAll(".js-smebundle-content-block").length > 0) {

        const smeBundleContentBlock = {
            init: () => {
                smeBundleContentBlock.showAddons();
                smeBundleContentBlock.hideExpand();
                smeBundleContentBlock.hideCollapse();
            },
            showAddons: () => {
                const allAddons = document.querySelectorAll(".js-smebundle-addon");

                allAddons.forEach((addOn) => {
                    addOn.addEventListener("click", () => {
                        const idToDispaly = document.getElementById(addOn.title);
                        const idToDispalyDesc = document.getElementById(addOn.title + "Desc");
                        const idToDispalyContact = document.getElementById(addOn.title + "Contact");
                        document.querySelectorAll('.displayedTile').forEach(function (el) {
                            el.classList.add("hidden");
                            el.classList.remove("displayedTile");
                        });
                        idToDispaly.classList.remove("hidden")
                        idToDispaly.classList.add("displayedTile");
                        idToDispalyDesc.classList.remove("hidden")
                        idToDispalyDesc.classList.add("displayedTile");
                        idToDispalyContact.classList.remove("hidden");
                        idToDispalyContact.classList.add("displayedTile");
                   });
                });
            },
            hideExpand: () => {
                const expand = document.querySelectorAll(".linkbutton__downarrow");
                expand.forEach((expandItem) => {
                    expandItem.addEventListener("click", () => {
                        expandItem.classList.add("hide_expand");
                        expandItem.previousElementSibling.classList.remove("smeb__collapsed--text");
                        expandItem.nextElementSibling.classList.remove("hide_expand");
                    });
                });
            },
            hideCollapse: () => {
                const collapse = document.querySelectorAll(".linkbutton__uparrow");
                collapse.forEach((collapseItem) => {
                    collapseItem.addEventListener("click", () => {
                        collapseItem.classList.add("hide_expand");
                        collapseItem.previousElementSibling.previousElementSibling.classList.add("smeb__collapsed--text");
                        collapseItem.previousElementSibling.classList.remove("hide_expand");
                    });
                });
            },
        };
        smeBundleContentBlock.init();
    }
})();

